import { Grid, Stack } from '@mui/material';
import MainCard from 'components/MainCard';
import Icon from "@mui/material/Icon";


const AlertStaticBox = ({icon, title, sx, children, iconColor='#bbb', border=true}) => 
{
  return (
    <MainCard border={border} contentSX={{m:0, p:0}} sx={{width:'100%', margin:'auto', ...sx}} >
        <Grid container p={0} m={0} pt={3} width='100%' >
            <Grid item xs={3} >
                <Stack direction="row" justifyContent="center" alignItems="center" height='100%'>
                    <Icon sx={{ fontSize: '100px', lineHeight:'100px', color:iconColor }}>{icon}</Icon>
                </Stack>
            </Grid>
            <Grid item xs={9} p={0} pr={2}>
                <Stack>
                    <h3>{title}</h3>
                    <Stack>
                        {children}
                    </Stack>
                </Stack>
            </Grid>                
        </Grid>
    </MainCard>
  )
}

export default AlertStaticBox